"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plus = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Plus = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b, _c = _a.width, width = _c === void 0 ? 45 : _c, _d = _a.height, height = _d === void 0 ? 45 : _d, _e = _a.style, style = _e === void 0 ? {} : _e;
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: __assign({ fill: 'white' }, style) },
        React.createElement("defs", null,
            React.createElement("path", { id: "EMPTY-CONTACTS-SVG-ICON-PATH", d: "M21 11h-8V3h-2v8H3v2h8v8h2v-8h8z" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "EMPTY-CONTACTS-SVG-ICON-MASK", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#EMPTY-CONTACTS-SVG-ICON-PATH" })),
            React.createElement("g", { fill: color, mask: "url(#EMPTY-CONTACTS-SVG-ICON-MASK)" },
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
};
exports.Plus = Plus;
//# sourceMappingURL=Plus.js.map